<template>
<div>
  <celebrate-graphics title="Congratulations">
    <template slot="content">
      <p class="text">
      Thank you for applying. {{ currentJob.companyName }} will contact you if there's a match. We've sent you an email confirmation, and you can review your application in Applied Jobs. Below are the details of the reward you could earn on successful hire.
      </p>
    </template>
  </celebrate-graphics>
  <divider />
  <div v-if="application.referralId">
    <a class="is-right" v-tooltip="'This is the user who referred you to the role'">
      What is this?
    </a>
    <h1 class="title is-6 heading">Referrer</h1>
    <user-row-card :user="referrer" />
    <divider />
    <h1 class="title is-6 heading">Referral Reward</h1>
    <reward :min="referrerRewardMin" :max="referrerRewardMax" :rewardPercentage="currentJob.rewardPercentage" cssClass="inline normal f-14" title="in VIBES/BTC/EOS *" :referrer="true" />
    <divider />
  </div>
  <h1 class="title is-6 heading">Jobseeker Reward</h1>
  <reward :min="referrerRewardMin" :max="referrerRewardMax" :rewardPercentage="currentJob.rewardPercentage" cssClass="inline normal f-14" title="in VIBES/BTC/EOS *" :referrer="application.referralId !== null" />
  <divider />
  <h6 class="title is-6 heading">* Reward terms</h6>
  <p class="text">This is 100% of your total Job Hire Reward. 50% is released when 30 days is completed after your start date. The next 25% is released when 60 days is completed, and the final 25% is released when 90 days is completed.</p>
  <p class="text">1.5m VIBES must be staked <a target="_blank" href="http://hirevibes.io/stake">here</a> to unlock this utility of choosing to receive your HireVibes reward in BTC or EOS. For more details see our <a target="_blank" href="http://hirevibes.io/faq">FAQ</a></p>
</div>
</template>

<script>
import { mapState } from 'vuex'
import UserRowCard from '@/components/general/user-row-card'
import Divider from '@/components/general/divider'
import Heading from '@/components/general/heading'
import Currency from '@/components/general/currency'
import CelebrateGraphics from '@/components/general/celebrate-graphics'
import GlobalData from '@/helpers/global-data'
import Reward from '@/components/jobs/reward'
import RewardHelper from '@/helpers/reward'

export default {
  components: {
    UserRowCard,
    Divider,
    Heading,
    Currency,
    GlobalData,
    CelebrateGraphics,
    Reward
  },
  computed: {
    ...mapState('jobs', [
      'currentJob'
    ]),
    ...mapState('applicationForm', [
      'application'
    ]),
    referrer () {
      return {
        id: this.application.referrerId,
        firstName: this.application.referrerFirstName,
        lastName: this.application.referrerLastName,
        profilePictureUrl: this.application.referrerProfilePictureUrl,
        role: this.application.referrerRole,
        location: this.application.referrerLocation,
        companyName: this.application.referrerCompanyName
      }
    },
    referralFraction () {
      return GlobalData.referralFraction()
    },
    referrerRewardMin () {
      const f = this.application.referralId ? this.referralFraction : 1
      return RewardHelper.user(this.currentJob.minReward, this.currentJob.rewardPercentage) * f
    },
    referrerRewardMax () {
      const f = this.application.referralId ? this.referralFraction : 1
      return RewardHelper.user(this.currentJob.maxReward, this.currentJob.rewardPercentage) * f
    }
  }
}
</script>

<style lang="scss" scoped>
.is-right {
  float: right;
  color: #888;
}
.heading {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/apply-confirmation.vue